import React, { Component } from 'react';

const allStars = Array.from({ length: 5 });
class RatingStar extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    const { editable, stars } = this.props;
    this.setState({
      editable: editable || false,
      stars,
    });
  }

  updateStar = (star) => {
    const { updateStar } = this.props;
    const { editable } = this.state;
    if (editable) {
      this.setState({ stars: star });
      updateStar(star, editable);
    }
  };

  render() {
    const { stars, editable } = this.state;

    return (
      <>
        <div className="comment__icon-wrapper">
          {allStars.map((_, index) => (index < stars ? (
            <span
              role="none"
              className="comment__icon-star"
              key={index}
              onClick={() => {
                this.updateStar(index + 1);
              }}
            />
          ) : (
            <span
              role="none"
              className="comment__icon-star-o"
              key={index}
              onClick={() => {
                this.updateStar(index + 1);
              }}
            />
          )))}
          {editable ? <input hidden value={stars} name="rating" onChange={() => {}} /> : ''}
        </div>
      </>
    );
  }
}
export default RatingStar;
